import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { AlertPopupComponent, ConfirmPopupComponent } from '.';
import RootStore, { ROOT_STORE } from 'src/stores/rootStore';

interface IPopupContainerInjectedProps {
  [ROOT_STORE]: RootStore;
}


export const PopupContainer = inject(ROOT_STORE)(observer(({ ...props }) => {
  const { rootStore: { popupStore } } = props as IPopupContainerInjectedProps;
  return (
    popupStore.list.length ? <div className='popup-bg'>
      {
        popupStore.list.map(item =>
          item.type === 'alert' ? <AlertPopupComponent key={item.id} {...item} />
            : item.type === 'confirm' ? <ConfirmPopupComponent key={item.id} {...item} />
              : <React.Fragment key={item.id}/>
        )}
    </div>
    :
    <></>
  );
}));


// WEBPACK FOOTER //
// ./src/components/layout/popup/popupContainer.tsx